import React from 'react'
import { FacebookShare, TwitterShare, LinkedinShare, MailShare } from '../components/SocialMediaShare/platforms'
import {
  TwitterIcon,
  LinkedinIcon,
  TelegramIcon,
  Youtubelcon,
  DiscordIcon,
  MailIcon,
  CoinMarketCapIcon,
  CoingeckoIcon,
  DextoolsIcon
} from '../components/Svg/index'
import { SocialMediaIcon } from '../components/SocialMediaIcon'

export enum SocialPlatformName {
  TWITTER = 'Twitter',
  TELEGRAM = 'Telegram',
  COINMARKETCAP = 'Coinmarketcap',
  COINGECKO = 'Coingecko',
  EMAIL = 'Email',
  DISCORD = 'Discord',
  LINKEDIN = 'Linkedin',
  YOUTUBE = 'Youtube',
  FACEBOOK = 'Facebook',
  DEXTOOLS = 'Dextools'
}

export const getSocialIconByName = ({
  platformName,
  href,
  disabled
}: {
  platformName?: string
  href?: string
  disabled?: boolean
}) => {
  const props = { href, platformName, disabled }
  switch (platformName) {
    case SocialPlatformName.TWITTER:
      return <SocialMediaIcon icon={TwitterIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.LINKEDIN:
      return <SocialMediaIcon icon={LinkedinIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.TELEGRAM:
      return <SocialMediaIcon icon={TelegramIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.YOUTUBE:
      return <SocialMediaIcon icon={Youtubelcon} {...{ ...props }} customIcon />
    case SocialPlatformName.DISCORD:
      return <SocialMediaIcon icon={DiscordIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.EMAIL:
      return <SocialMediaIcon icon={MailIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.COINMARKETCAP:
      return <SocialMediaIcon icon={CoinMarketCapIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.COINGECKO:
      return <SocialMediaIcon icon={CoingeckoIcon} {...{ ...props }} customIcon />
    case SocialPlatformName.DEXTOOLS:
      return <SocialMediaIcon icon={DextoolsIcon} {...{ ...props }} customIcon />
    default:
      return null
  }
}

export const getSocialShareButton = (platformName: string, url: string, title: string) => {
  switch (platformName) {
    case SocialPlatformName.FACEBOOK:
      return <FacebookShare url={url} title={title} />
    case SocialPlatformName.TWITTER:
      return <TwitterShare url={url} title={title} />
    case SocialPlatformName.LINKEDIN:
      return <LinkedinShare url={url} title={title} />
    case SocialPlatformName.EMAIL:
      return <MailShare url={url} title={title} />
    default:
      return null
  }
}
